import omit from 'lodash-es/omit'
import config from 'config'

function isUsableImage (value) {
  return Boolean(value) && value !== 'no_selection'
}

/**
 * Omit some variant fields to prevent overriding same base product fields
 */
export default function omitSelectedVariantFields (selectedVariant) {
  // Copy: `config` arrays may be frozen/non-extensible in SSR — do not mutate in place.
  const fieldsToOmit = [...(config.products.omitVariantFields || [])]
  if (!isUsableImage(selectedVariant?.image)) {
    fieldsToOmit.push('image')
  }
  if (!isUsableImage(selectedVariant?.thumbnail)) {
    fieldsToOmit.push('thumbnail')
  }
  if (!isUsableImage(selectedVariant?.small_image)) {
    fieldsToOmit.push('small_image')
  }
  return omit(selectedVariant, fieldsToOmit)
}
